// @ts-ignore
import {FeePolicyRequestParams, GetFeePolicy, GetFeePolicyRequest} from 'supporter';

import {ActionContext} from 'vuex';
import {api} from '@/api';
import {FeePolicyState} from '@/types/fee';

export default {
  namespaced: true,
  state: {
    query: {
      confirmationType: '',
      page: '',
      size: '',
      startMonth: '',
      startYear: '',
      termType: '',
      endMonth: '',
      endYear: '',
      keyword: '',
      searchType: '',
      platform: ''
    },
    response: {
      contents: [],
      totalCount: 0
    }
  },
  actions: {
    async getFeePolicy({commit}: ActionContext<FeePolicyState, any>, params: GetFeePolicyRequest): Promise<void> {
      await api.getFeePolicy(params).then((res: any): void => {
        commit('SET_FEE_POLICY_DATA', res.data);
      });
    }
  },
  mutations: {
    SET_FEE_POLICY_DATA(state: FeePolicyState, response: GetFeePolicy): void {
      state.response = response;
    },
    SET_FEE_QUERY_PARAMS(state: FeePolicyState, query: FeePolicyRequestParams): void {
      state.query = query;
    }
  },
  getters: {
    feePolicy(state: FeePolicyState): GetFeePolicy {
      return state.response;
    },
    queryParams(state: FeePolicyState): FeePolicyRequestParams {
      return state.query;
    }
  }
};
